import Chosen from "../../../forms/Inputs/Select/Chosen";
import Prices from "../../Prices";
import {gsap} from "gsap";
import PricesList from "../List/List";
import PricesNavigation from "../Navigation/Navigation";
import PricesTabTools from "../TabTools/TabTools";

const PricesVehicle = {

    init(section) {
        this.section = section;
        this.row = this.section.find(".row.item");

        this.start();
        this.bind(this.row);
    },

    start() {
        $.each(this.section, (index, section) => {
            this.inactiveAddButton(section);
        });
    },

    bind(row) {
        const inputs = row.find("input");
        const selects = row.find("select");

        row.find(".delete button").on("click", (evt) => {
            this.tryToDelete(evt);
        });

        inputs.on("keypress", function (evt) {
            if (evt.charCode === 13) {
                const input = $(evt.currentTarget);
                let next = input.closest('.asInput').next().find('input');
                if (!next.length) {
                    next = input.closest('.row').next().find('.asInput').first().find('input');

                    if (!next.length) {
                        input.blur();
                    }
                }
                next.trigger('focus');
            }
            return evt.charCode === 0 || evt.charCode === 44 || /\d/.test(String.fromCharCode(evt.charCode));
        });

        inputs.on("focus", (evt) => {
            $(evt.currentTarget).select();
        });

        inputs.on("change", (evt) => {
            this.onInputsChange($(evt.currentTarget));
        });

        selects.on("input change", (evt) => {
            this.onSelectChange($(evt.currentTarget));
        });
    },

    onInputsChange(input) {
        let wait;
        let row = input.parents().closest(".row.item");
        let cell = input.parents().closest(".cell");
        let defaultValue = input.data("value");
        let section = input.parents().closest("div.categorySection");

        clearTimeout(wait);

        let value = input.val();
        value = this.parseValue(value);
        input.val(value);

        if (value === '0,00') {
            input.addClass("bad");
            cell.addClass("bad");

        } else {
            input.removeClass("bad");
            cell.removeClass("bad");
        }

        if (defaultValue !== value) {
            input.addClass("changed");
            cell.addClass("changed");
            row.addClass("changed");

            PricesList.setSectionChanged(section);

            wait = setTimeout(() => {
                PricesList.prepareData();
            }, 200);
        }
    },

    onSelectChange(input) {
        let wait;
        let row = input.parents().closest(".row.item");
        let cell = input.parents().closest(".cell");
        let section = input.parents().closest("div.categorySection");

        let selectedOption = input.find('option:selected');

        clearTimeout(wait);

        let value = input.val();

        if (selectedOption.length > 0) {
            input.addClass("changed")
                .removeClass("bad");

            cell.removeClass("bad");

            row.addClass("changed")
                .attr("data-vehicle_id", value)
                .data("vehicle_id", value);

            row.find(".vehicleName")
                .attr("href", "/" + window.T.rental.routes.vehicle + "/" + selectedOption.attr("url"))
                .find('.category').text(selectedOption.attr('acriss')).end()
                .find('.name').html('<strong>' + selectedOption.text() + '</strong>' + ' - ' + selectedOption.attr('body')).end()

            row.removeClass("empty");

            PricesList.setSectionChanged(section);

            wait = setTimeout(() => {
                PricesList.prepareData();
                row.find('input[name*="price_"]').first().trigger("focus");
            }, 500);

        } else {
            input.addClass("bad");
            cell.addClass("bad");
            row.addClass("empty");
        }
    },

    add(section) {
        // console.log('Row.add', section)
        let randomID = "N" + PricesList.generateRandomChars(10);
        let newRow = section.find(".template").clone().contents();
        let newVehicle = section.find('.table .item.new').addClass('ready');

        $(newRow)
            .addClass("empty").attr("id", randomID)
            // .bind("input").addClass("bad")
            .insertAfter(section.find(".row.header"));

        this.prepareSelect(section);

        setTimeout(() => {
            $(newRow).find("select").trigger("change");
        }, 250);

        this.bind(newRow);
        this.inactiveAddButton(section);

        // PricesList.bindSortableTable();

        if (section.hasClass("empty")) {
            section.removeClass("empty");
        }
    },

    prepareSelect(section) {
        const options = section.find('.table .row.item.new').not('.ready').find('select option');
        const vehicles = section.find('.table .row.item').not('.empty');

        options.each((i, option) => {
            if (vehicles.filter('[data-vehicle_id="' + $(option).val() + '"]').length) {
                $(option).remove();
            }
        })

        Chosen.init(section.find('.table .row.item.new'));

    },

    tryToDelete(evt) {
        let row = $(evt.currentTarget).parents().closest(".row.item");
        let section = $(evt.currentTarget).parents().closest("div.categorySection");

        if ($(row).hasClass("new")) {
            $(row).remove();

            this.checkIfSectionsEmpty(section);
            PricesList.prepareData();
            this.inactiveAddButton(section);
            return;
        }

        this.deleteWarning(row);
    },

    deleteWarning(row) {
        const warning = $(".templates .deleteWarning").clone().css({opacity: 0});
        row.append(warning);
        gsap.to(warning, {opacity: 1, duration: 0.3});

        warning.find('button.close').click((evt) => {
            const warning = $(evt.currentTarget).closest('.deleteWarning');
            gsap.to(warning, {
                opacity: 0, duration: 0.3, onComplete: () => {
                    warning.remove();
                }
            })
        })

        warning.find('button.delete').click((evt) => {
            this.delete(row);
            PricesList.prepareData();
        })
    },

    delete(row) {
        let pathname = window.location.pathname;
        let section = $(row).closest("div.categorySection");
        const page_id = window.ID_PAGE;
        let event = $(this).data("event");
        let data = {
            id: row.data("id")
        };

        $.ajax({
            type: 'POST',
            url: Prices.asyncUrl + `?go=${pathname}&event=delete&page_id=${page_id}`,
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: (response, textStatus, jqXHR) => {
                if (response.success === true) {
                    PricesTabTools.showAlert();

                    if (response.menu) {
                        PricesNavigation.el.html(response.menu);
                        PricesNavigation.init();
                    }

                    row.remove();

                    setTimeout(() => {
                        this.checkIfSectionsEmpty(section);
                        this.inactiveAddButton(section);
                    }, 200);
                } else {
                }
            },

            error: (xhr, status, error) => {
                console.error('Error:', error);
                // Handle error here if needed
            }
        })
    },

    parseValue(value) {
        let numberOfCommas = value.split(",").length - 1;
        let numberOfDots = value.split(".").length - 1;

        value = value.replaceAll(/\s/g, "");
        value = value.replaceAll(/€/g, "");

        if (numberOfCommas === 1 && numberOfDots === 0) {
            value = value.replaceAll(/,/g, ".");
        }

        if (value) {
            value = parseFloat(value).toLocaleString("sk-SK", {
                minimumFractionDigits: PricesList.decimalsParam,
                maximumFractionDigits: PricesList.decimalsParam
            });
        }

        return value;
    },

    inactiveAddButton(section) {

        setTimeout(() => {
            let addButton = $(section).find("button.add");

            if (this.isAvailableVehicle(section)) {
                addButton.removeClass("emptyVehicles");
            } else {
                addButton.addClass("emptyVehicles");
            }
        }, 100);
    },

    isAvailableVehicle(section) {
        const options = $(section).find('.template .vehicle select option');
        const vehicles = $(section).find('.table .item');

        return options.length > vehicles.length;
    },

    removeNewRows(section) {
        if (section) {
            section.find(".table.grid .item.new").remove();

            this.checkIfSectionsEmpty(section);
            return;
        }

        $(".table.grid .item.new").remove();
    },

    checkIfSectionsEmpty(section) {
        // console.log('checkIfSectionsEmpty')
        let rows = section ? section.find(".table.grid .row.item") : $(".table.grid .row.item");

        if (rows.length === 0) {
            section.addClass("empty");
        }
    },
}

export default PricesVehicle;